export class UtmParamsHelper {

  static readonly CampaignKey = "Campaign";
  static readonly KKZKey = "KKZ";
  static readonly SourceKey = "Source";
  static readonly MediumKey = "Medium";

  static readonly MatchingKeys = ['facebook', 'meta', 'google'];

  static extractSourceDomainToUtmParams(
    params: { [key: string]: string },
    isAdminUser: boolean,
    isPlanerUser: boolean,
  ): UtmParamMap {
    const out = new Map<string, string>();

    if ( !params ) return out;

    // Push in the exact order you want:
    const ORDER = [this.CampaignKey, this.KKZKey, this.SourceKey, this.MediumKey] as const;

    for ( const key of ORDER ) {
      const raw = params[key];
      if ( raw == null ) continue;
      const source = params[this.SourceKey]?.toLowerCase();
      const isMatchingSource = this.MatchingKeys.some(match => source.includes(match));

      if ( isMatchingSource && key === this.CampaignKey ) {
        const res = this.getOptimizedUtmParams(raw, { isAdmin: isAdminUser, isPlaner: isPlanerUser });
        out.set(key, res.text);
        if ( res.extra ) {
          out.set(res.extra.key, res.extra.value);
        }
      } else {
        out.set(key, raw);
      }
    }

    return out;
  }

  static getOptimizedUtmParams(
    input: string,
    opts: { isAdmin: boolean; isPlaner: boolean }
  ): OptimizeResult {
    if ( opts.isAdmin ) {
      return { text: input };
    }

    const seg = this.parseCampaignSegments(input);
    const parts: string[] = [];

    if ( seg.fx ) {
      parts.push(seg.fx);
    }
    if ( seg.fy ) {
      parts.push(seg.fy);
    }

    const text = parts.length ? parts.join(" ") : input;
    const extra = opts.isPlaner && seg.fi ? { key: this.KKZKey, value: seg.fi } : undefined;

    return { text, extra };
  }

  static parseCampaignSegments( input: string ): Record<string, string> {
    const map: Record<string, string> = {};
    const re = /_([a-z]{2})-([\s\S]*?)(?=_[a-z]{2}-|$)/gi;
    let m: RegExpExecArray | null;
    while ( (m = re.exec(input)) !== null ) {
      const key = m[1].toLowerCase();
      map[key] = m[2].trim();
    }
    return map;
  }

  static stripQuery(url: string): string {
    try {
      const u = new URL(url);
      u.search = "";
      u.hash = "";
      return u.toString();
    } catch {
      const q = url.indexOf("?");
      const base = q >= 0 ? url.slice(0, q) : url;
      const h = base.indexOf("#");
      return h >= 0 ? base.slice(0, h) : base;
    }
  }
}

export type UtmParamMap = Map<string, string>;
export type OptimizeResult = { text: string; extra?: { key: string; value: string } };
